import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

const PrivateRoute: React.FC = () => {
  // 检查用户是否登录
  const token = localStorage.getItem('token')
  const location = useLocation()

  return token ? <Outlet /> : <Navigate to="/login" state={{ from: location }} replace />
}

export default PrivateRoute
